import ring from './ring.png';
import ring2x from './ring@2x.png';
import ring3x from './ring@3x.png';
import ring4x from './ring@4x.png';

export default {
    1: ring,
    2: ring2x,
    3: ring3x,
    4: ring4x,
};
